import { isAfter, subMinutes } from 'date-fns';

/**
 * Transforms an exchangeable reservation from API into an ExchangeableReservation object.
 * (Equals 1 reservation fulfillment per passenger)
 */
export function transformExchangeableReservation(
    reservation: ApiSchema['Reservation'],
    apiBooking: ApiSchema['Booking'],
): ExchangeableReservation {
    const fulfillment = apiBooking.fulfillments?.find(f => f.issuer !== 'TOFT' && f.bookingParts?.some(bp => bp.id === reservation.id));
    const relatedApiTrip = apiBooking.trips?.find(t => reservation.tripCoverage?.coveredTripIds?.includes(t.id));
    const trip = relatedApiTrip ? transformBookedTrip(relatedApiTrip) : undefined;
    const id = reservation.id;
    const fulfillmentId = fulfillment?.id;
    const passengerIds = reservation.passengerIds || [];
    const type = 'Reservation';
    const status = reservation.status;
    const EXCHANGE_LEAD_TIME = 45;
    const exchangeDeadline = trip?.departureTime ? subMinutes(trip?.departureTime, EXCHANGE_LEAD_TIME) : undefined;
    const isExpired = exchangeDeadline ? isAfter(zurichDate(), exchangeDeadline) : false;
    const isExchangeable = !!trip && reservation.status === 'FULFILLED' && !isExpired;

    return {
        id,
        fulfillmentId,
        passengerIds,
        type,
        status,
        trip,
        isExchangeable,
        exchangeDeadline,
        isExpired,
    };
}
